module.exports = __webpack_public_path__ + "static/media/74.96ac1622.jpg";